function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  fillRule: "nonzero",
  d: "M0 0h12v12H0z"
}), React.createElement("path", {
  fill: "#595959",
  d: "M6.632 0c1.024 0 1.856.272 2.464.848.592.544.896 1.296.896 2.256 0 .72-.208 1.344-.592 1.872-.16.192-.608.608-1.312 1.232a3.212 3.212 0 0 0-.736.864 2.291 2.291 0 0 0-.304 1.184v.368H5.752v-.368c0-.528.096-.992.304-1.392.208-.48.752-1.088 1.616-1.856.256-.256.432-.448.544-.576.304-.4.464-.816.464-1.264 0-.64-.176-1.136-.528-1.488-.384-.384-.912-.56-1.584-.56-.784 0-1.376.256-1.776.784-.336.448-.512 1.056-.512 1.84H3c0-1.12.32-2.016.944-2.688C4.6.352 5.496 0 6.632 0zm-.224 9.744c.272 0 .496.08.688.272.176.176.272.4.272.672a.928.928 0 0 1-.272.688 1.01 1.01 0 0 1-.688.272.928.928 0 0 1-.688-.272.93.93 0 0 1-.288-.688c0-.272.096-.496.288-.672.176-.192.4-.272.688-.272z"
}));

var SvgIcQuestion = function SvgIcQuestion(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIcQuestion, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic-question.dd66835b.svg";
export { ForwardRef as ReactComponent };